module.exports = __webpack_public_path__ + "img/shop.25727031.svg";